import axios from "axios";
// Default to localhost http://127.0.0.1:8000/api/v1 https://admin.finapro.finaleasegroup.com/api/v1
const API_URL = "https://admin.finapro.finaleasegroup.com/api/v1";
export const BACKEND_URL = API_URL.replace(/\/api\/v1\/?$/, "");
export const AZURE_LOGIN_URL = `${BACKEND_URL}/login-azure`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
